import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@unhead/vue/client';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import googleAnalytics from './plugins/googleAnalytics';
import router from './router';
import VueRecaptchaPlugin from 'vue-recaptcha';
import '@/assets/styles/main.scss';

const app = createApp(App);
const pinia = createPinia();
const head = createHead();

app.use(pinia);
app.use(head);
app.use(vuetify);
app.use(router);
app.use(googleAnalytics, { router }); // Pass router for automatic page tracking
app.use(VueRecaptchaPlugin, {
  v2SiteKey: '6Ld1Tb8ZAAAAAHFYCv_TbcSqFGX8Whya-lp105Ok'
});

app.mount('#app');
